<template>
  <div class="basetextarea">
    <label>{{ labelText }}</label>
    <b-form-textarea
      class="longtermorder__form-textarea"
      :rows="rows"
      :max-rows="maxRows"
      :value="value"
      :disabled="disabled"
      @input="$emit('input', $event)"
    ></b-form-textarea>
  </div>
</template>

<script>
export default {
  name: 'BaseTextarea',
  props: {
    labelText: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 1
    },
    maxRows: {
      type: Number,
      default: 6
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.basetextarea {
  display: flex;
  align-items: center;
  label {
    flex: 0 0 80px;
    margin-bottom: 0;
  }
  textarea {
    font-size: 13px;
  }
}

.widerlabel {
  label {
    flex: 0 0 100px;
  }
}
</style>
